import React, { useContext, useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import { AuthContext } from "../context/AuthContext";
import { db, serverTime } from "../Utils/firebase";
import { checkUrl } from "../Utils/Validation";

function AddLink({ list }) {
  const { userAuth, setUserData } = useContext(AuthContext);
  const [url, setUrl] = useState("");
  const [section, setSection] = useState("");
  const [descript, setDescript] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [mount, setMount] = useState(true);
  const [btnText, setBtnText] = useState("Add");

  const limitChar = (e) => {
    if (
      e.target.value.length > e.target.maxLength &&
      e.keyCode !== 46 &&
      e.keyCode !== 8
    ) {
      e.preventDefault();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validUrl = checkUrl(url);
    if (url !== "" && descript !== "") {
      if (validUrl === true) {
        setLoading(true);
        setError(null);
        setBtnText("Checking ...");
        const linkData = {
          id: uuidv4(),
          url: url.trim().toString(),
          description: descript.trim().toString(),
          section: section !== "" ? section.trim().toString() : "",
          create_at: new Date(),
        };
        db.collection("user")
          .doc(userAuth.uid)
          .get()
          .then((doc) => {
            const linkNum = doc.data().link.length;
            const result = doc.data().link;
            if (linkNum < 15) {
              if (mount) {
                setBtnText("Adding ...");
              }
              db.collection("user")
                .doc(userAuth.uid)
                .update({
                  link: [linkData, ...result],
                  updateAt: serverTime,
                })
                .then(() => {
                  db.collection("user")
                    .doc(userAuth.uid)
                    .get()
                    .then((doc) => {
                      setUserData(doc.data());
                      if (mount) {
                        setLoading(false);
                        setBtnText("Add");
                        setUrl("");
                        setDescript("");
                        setSection("");
                      }
                    })
                    .catch((error) => {
                      if (mount) {
                        setError(error.code);
                        setLoading(false);
                        setBtnText("Add");
                      }
                    });
                })
                .catch((error) => {
                  if (mount) {
                    setError(error.code);
                    setLoading(false);
                    setBtnText("Add");
                  }
                });
            } else {
              if (mount) {
                setError("Maximum 15 Links");
                setLoading(false);
                setBtnText("Add");
              }
            }
          })
          .catch((error) => {
            if (mount) {
              setError(error.code);
              setLoading(false);
              setBtnText("Add");
            }
          });
      } else {
        setError("URL is not valid");
      }
    } else {
      setError("Data cannot be empty!");
    }
  };

  useEffect(() => {
    return () => {
      setMount(false);
    };
  }, []);

  return (
    <div className="add-link divContent darktextColor darkdivColor">
      <div className="head-tab">
        <h5 className="textTitle textMedium">New</h5>
        <p className="text">Complete the form!</p>
      </div>
      <form className="link-form" onSubmit={handleSubmit}>
        <div className="grup-input">
          <label>
            <span className="text">Link : </span>
            <input
              type="text"
              name="link"
              id="link"
              maxLength={1024}
              className="input-1"
              placeholder="URL : `https://www.sitename.com/anchor`"
              onChange={(e) => setUrl(e.target.value)}
              value={url}
              disabled={loading}
            />
          </label>
        </div>

        <div className="grup-input">
          <label>
            <span className="text">Description : </span>
            <input
              type="text"
              className="input-1"
              name="description"
              id="description"
              maxLength={48}
              onKeyDown={limitChar}
              onKeyUp={limitChar}
              onKeyPress={limitChar}
              onChange={(e) => setDescript(e.target.value)}
              placeholder="Example : `My YouTube Channel`"
              disabled={loading}
              value={descript}
            />
          </label>
        </div>
        <div className="grup-input">
          <label>
            <span className="text">
              Section : (<i className="textSmall">Optional</i>)
            </span>
            <input
              list="sections"
              className="input-1"
              name="section"
              id="section"
              onChange={(e) => setSection(e.target.value)}
              placeholder="Leave it Empty (All Link)"
              maxLength={32}
              value={section}
              disabled={loading}
            />
            <datalist id="sections">
              {list.map((item, index) => {
                return (
                  <option key={index} value={item}>
                    {item}
                  </option>
                );
              })}
            </datalist>
          </label>
        </div>

        <button
          className={
            loading
              ? "btn-in darktextColor textTitle disable"
              : "btn-in darktextColor textTitle "
          }
          disabled={loading}
          type="submit"
        >
          {btnText}
        </button>
      </form>
      {error && <p className="error text">{error}</p>}
    </div>
  );
}

export default AddLink;
